import {SurveyQuestionInterface, SurveyResultInterface} from "../../pages/SurveyResult/interfaces";

export enum VisionStatementStatus {
  Created = 2
}

export interface VsSurveyRequest {
  id: string;
  created: string;
  deadline: string;
  completed: string;
  questions: Array<SurveyQuestionInterface>;
  surveyResult: SurveyResultInterface;
}

export interface VisionStatementInterface {
  id: string;
  surveyId: string | null;
  title: string;
  description: string;
  deadline: string;
  progress: number;
  development: number;
  effort: number;
  onTrack: number;
  avgGap: number;
  status: VisionStatementStatus;
  questions: Array<SurveyQuestionInterface>;
  surveyRequests: Array<VsSurveyRequest>;
  customerCategoryId: string;
  goalsTotal: number;
  goalsCompleted: number;
  activitiesTotal: number;
  activitiesCompleted: number;
}

export enum VisionStatementPartStatus {
  Done = 1,
}

export interface VisionStatementGoal {
  id: string;
  title: string;
  description: string;
  deadline: string;
  created: string;
  development: number;
  engagement: number;
  status: VisionStatementPartStatus;
  actions: Array<VisionStatementAction>;
}

export interface VisionStatementActivity {
  id: string;
  title: string;
  description: string;
  deadline: string;
  created: string;
  status: VisionStatementPartStatus;
}

export interface VisionStatementAction {
  id: string;
  goal_id: string;
  title: string;
  description: string;
  deadline: string;
  created: string;
  status: VisionStatementPartStatus;
}